(function() {
	'use strict';

	angular
		.module('app.leanProjects')
		.directive('kanbanCardDrag', kanbanCardDrag);

	kanbanCardDrag.$inject = ['kanbanDragService'];

	function kanbanCardDrag(kanbanDragService) {
		return {
			restrict: 'A',
			link: link
		};

		function link(scope, element, attrs) {
			var node = element[0];
			node.setAttribute('draggable', 'true');

			node.addEventListener('dragstart', function(event) {
				if (event.target && event.target.closest &&
						event.target.closest('.card-a3-icon, .card-name a')) {
					event.preventDefault();
					return;
				}
				kanbanDragService.set(scope.$eval(attrs.kanbanCardDrag));
				element.addClass('kanban-card-dragging');
				if (event.dataTransfer) {
					event.dataTransfer.effectAllowed = 'move';
					try {
						event.dataTransfer.setData('text/plain', '');
					} catch (e) {}
				}
			});

			node.addEventListener('dragend', function() {
				element.removeClass('kanban-card-dragging');
				kanbanDragService.clear();
			});
		}
	}
})();
